export default "__VITE_ASSET__Bd$QY1hw__"